module.exports = __webpack_public_path__ + "img/ic_device_master.8c4bf91b.png";